module.exports = __webpack_public_path__ + "img/MetaV_Isotipo.d422d882.png";